const ru = {
  ACTIVITY: 'Активность',
  ADD_INTERVAL: 'Добавить Интервал',
  CREATE_ACTIVITY: 'Новая Активность',
  CREATE_FILTER_CONFIGURATION: 'Cоздать Конфигурацию фильтра',
  CONFIRM_FILTER_DELETE: 'Вы уверены что хотите удалить конфигарацию фильтров?',
  RECORDS: 'Записи',
  RUNNING: 'Активен',
  SAVE: 'Сохранить',
  SEARCH: 'Поиск',
  SAVE_FILTER_CONFIGURATION: 'Сохранить',
  SELECT_TIMEZONE: 'Выберите Таймзону',
  SELECT_TYPES: 'Выберите Типы',
  SELECT_ACTIVITY: 'Выберите Активность',
  SELECT_TAGS: 'Выбрать Теги',
  SELECT_FILTER: 'Выбрать Фильтр',
  SETTINGS: 'Настройки',
  START_ACTIVITY: 'Начать',
  LOG_ACTIVITY: 'Записать',
  STATUS: 'Статус',
  STOPPED: 'Стоп',
  STOP: 'Остановить',
  START: 'Начало',
  TIME: 'Время',
  SIGN_IN: 'Войти',
  SUMMARY: 'Выкладка',
  TIMEZONE: 'Таймзона',
  TOTAL: 'Всего',
  GROUPED: 'Сгруппирован',
  EDIT: 'Редактировать',
  EDIT_USER: 'Редактировать Пользователя',
  EDIT_ACTIVITY: 'Редактировать Активность',
  ENTER_USERNAME: 'Введите ваше имя',
  ENTER_PASSWORD: 'Введите ваш пароль',
  FILTER_NAME_PLACEHOLDER: 'Введите имя для конфигурации фильтров',
  PASSWORD: 'Пароль',
  REPEAT_PASSWORD: 'Повторите пароль',
  PAUSED: 'Пауза',
  PAUSE: 'Приостановить',
  FINISH: 'Конец',
  FORGOT_PASSWORD: 'Забыл Пароль',
  HISTORY: 'История',
  INTERVALS: 'Интервалы',
  COMMENT: 'Коментарий',
  DURATION: 'Длительность',
  DOWNLOAD_HISTORY: 'Экспорт',
  EXPORT: 'Экспорт',
  EXPORT_PDF: 'PDF Отчет',
  EXPORT_PDF_ERROR_TITLE: 'Ошибка экспорта',
  EXPORT_PDF_LIMIT_EXCEEDED: 'Экспорт в PDF ограничен {limit} днями. Выбранный диапазон содержит {days} дней. Пожалуйста, выберите меньший диапазон дат.',
  EXPORT_PDF_NO_DATA: 'Нет данных для экспорта за выбранный период.',
  EXPORT_EXCEL: 'Excel Отчет',
  EXPORT_EXCEL_ERROR_TITLE: 'Ошибка экспорта',
  EXPORT_EXCEL_LIMIT_EXCEEDED: 'Экспорт в Excel ограничен {limit} днями. Выбранный диапазон содержит {days} дней. Пожалуйста, выберите меньший диапазон дат.',
  EXPORT_EXCEL_NO_DATA: 'Нет данных для экспорта за выбранный период.',
  TO: 'По',
  TODAY: 'Сегодня',
  THIS_WEEK: 'Эта неделя',
  THIS_MONTH: 'Этот месяц',
  ID: 'id',
  TYPE_ID: 'Тип активности',
  TYPES: 'Типы',
  YES: 'Да',
  YESTERDAY: 'Вчера',
  NO: 'Нет',
  NO_RESULTS: 'Ничего не найдено',
  NO_DATA_FOR_RANGE: 'Нет записей за выбранный период',
  NO_DATA_FOR_RANGE_AND_FILTERS: 'Нет записей за выбранный период и фильтры',
  NONE: 'Ничего',
  DELETE: 'Удалить',
  DELETE_ACTIVITY_CONFIRM: 'Вы уверены, что хотите удалить эту активность? Все интервалы будут удалены.',
  DELETE_INTERVAL: 'Удалить Интервал',
  DELETE_INTERVAL_CONFIRM: 'Вы уверены, что хотите удалить интервал?',
  INSERT_BETWEEN: 'Вставить между',
  INSERT_NEW: 'Вставить новый',
  USER: 'Пользователь',
  FIRST_NAME: 'Имя',
  LAST_NAME: 'Фамилия',
  LAST_WEEK: 'Прошлая Неделя',
  LAST_MONTH: 'Прошлый месяц',
  LOAD_MORE: 'Загрузить Больше',
  USER_NAME: 'E-Mail',
  LANGUAGE: 'Язык',
  SELECT_LANGUAGE: 'Выберите Язык',
  ON_START_ACTION: 'Действие при старте',
  FULL_PATH: 'Показывать полный путь к типу активности',
  RESTORE: 'Восстановить',
  CHANGE_PASSWORD: 'Изменить пароль',
  DARK_MODE: 'Тёмная тема',
  GOALS: 'Цели',
  ADD_RECORD: 'Добавить запись',
  CALENDAR: 'Календарь',
  CALENDAR_LIMIT_WARNING: 'Календарь ограничен {days} днями. Выбранный диапазон содержит {selected} дней. Показано {showingFrom} - {showingTo}.',
  COPY: 'Копировать',
  PASTE: 'Вставить',
  ACTIVITY_COPIED: '"{name}" скопировано. Нажмите на пустую область для вставки.',
  CANCEL: 'Отмена',

  // What's New
  WHATS_NEW_TITLE: 'Что нового',
  WHATS_NEW_GOT_IT: 'Понятно!',
  WHATS_NEW_CALENDAR_TITLE: 'Календарь',
  WHATS_NEW_CALENDAR_DESC: 'Визуализируйте своё время в удобном календаре:',
  WHATS_NEW_CALENDAR_FEATURE_1: 'Интерактивный недельный вид с масштабированием',
  WHATS_NEW_CALENDAR_FEATURE_2: 'Клик на пустое место для быстрого добавления',
  WHATS_NEW_CALENDAR_FEATURE_3: 'Перетаскивание краёв событий для изменения времени',
  WHATS_NEW_CALENDAR_FEATURE_4: 'Копирование и вставка активностей между днями',
  WHATS_NEW_CALENDAR_FEATURE_5: 'Умное определение промежутков между событиями',
  WHATS_NEW_BLOCKS_TITLE: 'Блочный вид',
  WHATS_NEW_BLOCKS_DESC: 'Компактная сетка с 15-минутными интервалами. Наведите для просмотра деталей, кликните для редактирования.',
  WHATS_NEW_PDF_TITLE: 'Экспорт в PDF',
  WHATS_NEW_PDF_DESC: 'Создавайте подробные PDF-отчёты с графиками и разбивкой активностей за любой период.',
  WHATS_NEW_UI_TITLE: 'Обновлённый интерфейс',
  WHATS_NEW_UI_DESC: 'Более чистый и современный дизайн с улучшенной навигацией.',
  WHATS_NEW_DARKMODE_TITLE: 'Быстрый доступ к тёмной теме',
  WHATS_NEW_DARKMODE_DESC: 'Переключатель тёмной темы теперь доступен прямо в боковом меню.',
  WHATS_NEW_FEEDBACK: 'Нашли проблему или хотите поделиться мнением об изменениях? Напишите нам:',
}

export default ru
